import { render, staticRenderFns } from "./Photoshop.vue?vue&type=template&id=362bf8f0&"
import script from "./Photoshop.vue?vue&type=script&lang=js&"
export * from "./Photoshop.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports